import React, { useState } from "react";

function App() {
  const [popup, setPopup] = useState(null);

  const handleCallClick = (place: any) => {
    setPopup(place);
  };

  const closePopup = () => setPopup(null);

  const callNumber = (number: any) => {
    window.location.href = `tel:${number}`;
  };

  return (
    <div className="min-h-full bg-[#F5F5EF]">
      <main className="min-h-screen flex flex-col items-center justify-center px-6 py-16">
        {/* Logo */}
        <div className="mb-10">
          <img
            src="ely_logo.png"
            alt="ELY Group"
            className="mx-auto w-24 sm:w-28 md:w-32 h-auto"
          />
        </div>

        {/* Title */}
        <div className="max-w-4xl w-full text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-eagle tracking-tight">
            ELY Locations
          </h1>
          <p className="mt-4 text-base sm:text-lg">
            Welcome to ELY. Where would you like to join us, Dublin or Maynooth?
            Choose your location to continue.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl w-full">
          
          {/* Dublin */}
          <div className="group block h-full rounded-xl border border-gray-200 bg-white shadow-card hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="flex flex-col h-full">
              <div className="flex-[2] min-h-60 overflow-hidden">
                <img
                  src="ely_wine_3.PNG"
                  alt="ELY Wine Bar - Dublin"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-[1] p-6 flex flex-col items-center text-center">
                <h2 className="text-2xl font-eagle">
                  ELY WINE BAR - Dublin
                </h2>

                <p className="mt-1 text-sm uppercase tracking-wide">
                  22 Ely Place, Dublin 2, D02 AH73
                </p>

                {/* Phone BELOW address */}
                <p
                  onClick={() => handleCallClick("dublin")}
                  className="mt-2 text-sm text-blue-600 underline cursor-pointer hover:text-blue-800"
                >
                  +353 1 6768986
                </p>

                <p className="mt-4">
                  An iconic wine bar experience in the heart of Dublin, serving
                  small plates, big plates, cocktails and fantastic wines.
                </p>

                <a
                  href="https://elywinebar-dublin.ie"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-block px-6 py-2 bg-[#155d68] text-white font-semibold rounded-lg shadow-md hover:bg-[#134b56]"
                >
                  Explore
                </a>
              </div>
            </div>
          </div>

          {/* Maynooth */}
          <div className="group block h-full rounded-xl border border-gray-200 bg-white shadow-card hover:shadow-lg transition-all duration-300 overflow-hidden">
            <div className="flex flex-col h-full">
              <div className="flex-[2] min-h-60 overflow-hidden">
                <img
                  src="maynooth_1.jpeg"
                  alt="ELY Wine Store - Maynooth"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-[1] p-6 flex flex-col items-center text-center">
                <h2 className="text-2xl font-eagle">
                  ELY WINE STORE - Maynooth
                </h2>

                <p className="mt-1 text-sm uppercase tracking-wide">
                  Convent Lane, Maynooth, Co. Kildare, W23 C9V9
                </p>

                {/* Phone BELOW address */}
                <p
                  onClick={() => handleCallClick("maynooth")}
                  className="mt-2 text-sm text-blue-600 underline cursor-pointer hover:text-blue-800"
                >
                  +353 1 5043709
                </p>

                <p className="mt-4">
                  A wine shop, bar, deli, and cafe in one, serving meals from
                  breakfast to dinner with 400 wines available.
                </p>

                <a
                  href="https://elywinestore-maynooth.ie/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-block px-6 py-2 bg-[#155d68] text-white font-semibold rounded-lg shadow-md hover:bg-[#134b56]"
                >
                  Explore
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Popup */}
      {popup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center shadow-lg">
            <h3 className="text-lg font-semibold mb-4">
              Are you sure you want to call{" "}
              {popup === "dublin"
                ? "ELY Wine Bar Dublin"
                : "ELY Wine Store Maynooth"}
              ?
            </h3>

            <div className="flex flex-col gap-3">
              <button
                onClick={() =>
                  callNumber(
                    popup === "dublin"
                      ? "+35316768986"
                      : "+35315043709"
                  )
                }
                className="bg-[#155d68] text-white py-2 rounded-lg"
              >
                Yes
              </button>

              <button
                onClick={() =>
                  callNumber(
                    popup === "dublin"
                      ? "+35315043709"
                      : "+35316768986"
                  )
                }
                className="bg-gray-200 py-2 rounded-lg"
              >
                Call the other location
              </button>

              <button
                onClick={closePopup}
                className="text-sm text-gray-500 mt-2"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;